import React, { useContext } from 'react';
import { Modal } from 'flowbite-react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import MyProceduresContext from '../context/ProceduresContext';
import MyProcedureClassesContext from '../context/ProcedureClassesContext';

import Loading from './Loading';
import ErrorWrapper from './ErrorWrapper';

export const cutSpaces = (text) => {
    return text.replace(/\n{3,}/, '\n\n').replace(/ +/g, ' ');
}

const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}

const ModalProceduresAdd = ({ isModalProceduresAddOpen, setIsModalProceduresAddOpen, setSuccessAlert, itemType }) => {
    const { addProcedure, loading, error, setError } = useContext(MyProceduresContext);
    const { procedureClasses } = useContext(MyProcedureClassesContext);

    const schema = yup.object().shape({
        procedureTitle: yup.string().required("El titulo es requerido").max(120, "El titulo no puede tener más de 120 caracteres").min(5, "El titulo no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        procedureDescription: yup.string().required("La descripción es requerida").max(640, "La descripcion no puede tener mas de 640 caracteres").min(5, "La descripción no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        procedureClassId: yup.string().matches(/^((?!-1).)*$/,"El tipo de " + (itemType === 1 ? "trámite" : "producto") + " catastral es requerido"),
        procedureFile: yup.mixed()
            .test({
                message: "El archivo debe ser un pdf menor de 10 Mb",
                test: (file) => {
                    if (file.length > 0) {
                        const isValid = ["pdf"].includes(file[0].type.split("/")[1])
                        if (!isValid) return false
                        return file[0].size <= 10000000
                    }
                    return true
                }
            })
    })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const res = await addProcedure(data, itemType)
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 3000);
        } else {
            reset()
            setError({ "error": false, "message": "" })
            setIsModalProceduresAddOpen(false)
            setSuccessAlert("Trámite agregado correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 3000);
        }
    }
    return (
        <Modal show={isModalProceduresAddOpen} position="top-center">
            <div className='flex flex-col p-6 w-[95%] mx-auto'>
                <div className='font-medium text-center'>
                    AGREGAR NUEVO {itemType === 1 ? "TRÁMITE" : "PRODUCTO"}
                </div>
                <p class='pb-6 font-light text-sm italic'>Los campos señalados con * son obligatorios.</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div class="grid grid-cols-1 gap-6">
                        <div class="relative z-0 mb-6 w-full group">
                            <input type="text" {...register("procedureTitle")} class={style.formInput} placeholder=" " />
                            <label class={style.formLabel}>Titulo*</label>
                            <ErrorWrapper error={errors.procedureTitle?.message} />
                        </div>
                        <div class="relative z-0 mb-6 w-full group">
                            <textarea rows="3" {...register("procedureDescription")} class={style.formInput} placeholder=" " />
                            <label class={style.formLabel}>Descripción*</label>
                            <ErrorWrapper error={errors.procedureDescription?.message} />
                        </div>
                        <div class="relative z-0 mb-6 w-full group">
                            <select defaultValue={"-1"} {...register("procedureClassId")} class={style.formInput}>
                                <option className='font-light' disabled value={"-1"}>No seleccionado</option>
                                {procedureClasses ? procedureClasses.map((procedureClass, index) => (
                                    <option className='font-light' key={index} value={procedureClass.procedureClassId}>{procedureClass.procedureClassName}</option>
                                )) : <option className='font-light' disabled value={"-1"}>Cargando...</option>}
                            </select>
                            <label class={style.formLabel}>Tipo de {itemType === 1 ? "trámite" : "producto"} catastral*</label>
                            <ErrorWrapper error={errors.procedureClassId?.message} />
                        </div>
                        <div class="flex relative z-0 mb-6 w-full group mx-auto">
                            <div className='w-[70%] mx-auto '>
                                <br />
                                <input type="file" {...register("procedureFile")} className={style.formInput} placeholder=" " />
                                <label className={style.formLabel}>Archivo pdf, no mayor a 10Mb. Si no se selecciona ninguno, se usará el archivo por defecto*</label>
                                <ErrorWrapper error={errors.procedureFile?.message} />
                            </div>
                        </div>

                    </div>
                    <div className='text-center flex mb-6'>
                        {error.error && <ErrorWrapper error={error.message} />}
                    </div>
                    <div className='flex flex-col w-[50%] mx-auto'>
                        {loading ? <Loading isLoading={true} /> : <button type="submit" class=" mx-auto bg-gray-300 border shadow hover:text-white hover:bg-green-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-6 text-center duration-300 w-full">Agregar {itemType === 1 ? "Trámite" : "Producto"}</button>}

                        <button type="button" class="mx-auto bg-gray-200 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center duration-300 w-full" onClick={() => setIsModalProceduresAddOpen(false)}>Cancelar</button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

export default ModalProceduresAdd;